export interface IApClassType {
  id: number;
  name: string;
  ratingPrereq: number | null;
  classPrereq: number | null;
  ratingOverkill: number | null;
}

export class ApClassType implements IApClassType {
  id: number;
  name: string;
  ratingPrereq: number | null;
  classPrereq: number | null;
  ratingOverkill: number | null;

  constructor(config: IApClassType) {
    this.id = config.id;
    this.name = config.name;
    this.ratingPrereq = config.ratingPrereq;
    this.classPrereq = config.classPrereq;
    this.ratingOverkill = config.ratingOverkill;
  }
}
